import { isEmpty } from 'lodash';

export class BaseUrlBuilder {
  params: Params = {};
  root: string;

  paramSeperator: string = '?';

  constructor(root: string) {
    this.root = root;
  }

  setParam(
    key: string,
    value: string | number | boolean,
    isJson: boolean = true,
    shouldEncode: boolean = true
  ): this {
    this.params[key] = shouldEncode
      ? encodeURIComponent(isJson ? JSON.stringify(value) : value)
      : isJson
      ? JSON.stringify(value)
      : value;

    return this;
  }

  get urlParams(): string {
    if (isEmpty(this.params)) {
      return '';
    }

    let urlParams: string = this.paramSeperator;
    Object.entries<Params>(this.params).forEach(([key, value]: [string, string], index: number) => {
      if (index > 0) {
        urlParams += '&';
      }
      urlParams += `${key}=${value}`;
    });

    return urlParams;
  }

  build(): string {
    return `${this.root}${this.urlParams}`;
  }
}
